import { PaginationProps, SortDirection } from 'utilities'

export type ProductsFilterDTO = {
  agreementEnd: string
  agreementName: string
  agreementStart: string
  brandName: string
  endDate: string
  maxAgreementBudget: number
  maxSKUs: number
  minAgreementBudget: number
  minSKUs: number
  productName: string
  projectName: string
  startDate: string
  tags: string
  ids?: number[]
}

export enum BrandProductsSortProps {
  NAME = 'name',
  TAGS = 'tags'
}

export type BrandProductsPaginationProps = PaginationProps<BrandProductsSortProps>

export enum BrandProductsRangeProps {
  AGREEMENT_BUDGET = 'AGREEMENT_BUDGET'
}

export const initialBrandProductsPaginationProps: BrandProductsPaginationProps = {
  page: 0,
  size: 15,
  sortProp: BrandProductsSortProps.NAME,
  sortDirection: SortDirection.DESC,
  totalElements: 0,
  totalPages: 0
}

export const initialBrandProductsFilter: ProductsFilterDTO = {
  agreementEnd: null,
  agreementName: '',
  agreementStart: null,
  brandName: null,
  endDate: null,
  maxAgreementBudget: null,
  maxSKUs: null,
  minAgreementBudget: null,
  minSKUs: null,
  productName: '',
  projectName: '',
  startDate: null,
  tags: ''
}

export const needTimeoutProps: Array<keyof ProductsFilterDTO> = [
  'productName', 'projectName', 'agreementName',
  'minAgreementBudget', 'maxAgreementBudget',
  'tags'
]
